import { MenuItem, MenuItemProps } from '@chakra-ui/react'

type ProfileMenuItemProps = MenuItemProps

export const ProfileMenuItem = ({
  children,
  ...props
}: ProfileMenuItemProps) => {
  return (
    <MenuItem
      iconSpacing="8px"
      borderRadius="32px"
      padding="7px 10px"
      _hover={{
        bg: 'presets.neutral.20',
      }}
      _active={{
        backgroundColor: 'presets.turquoise.100',
        color: 'presets.neutral.0',
      }}
      _focus={{
        backgroundColor: 'presets.neutral.20',
      }}
      {...props}
    >
      {children}
    </MenuItem>
  )
}
